"use strict";
$(document).ready(() => {
    // console.log('in linkedin redirect file');
    let facebookIcons = [];
    const facebookIconsIntroPara = document.querySelectorAll('.intro-para .icon-fb');
    const facebookIconsEventAgenda = document.querySelectorAll('.section-events-listing .event-section .social-nav .icon-fb');
    // console.log(linkedIcons);
    const facebookIconsArticleContent = document.querySelectorAll('.article-main-content .icon-fb');
    if (facebookIconsIntroPara && facebookIconsIntroPara.length > 0) {
        facebookIcons = [
            ...facebookIcons,
            ...facebookIconsIntroPara,
        ];
    }
    if (facebookIconsEventAgenda && facebookIconsEventAgenda.length > 0) {
        facebookIcons = [
            ...facebookIcons,
            ...facebookIconsEventAgenda,
        ];
    }
    if (facebookIconsArticleContent && facebookIconsArticleContent.length > 0) {
        facebookIcons = [
            ...facebookIcons,
            ...facebookIconsArticleContent,
        ];
    }
    facebookIcons.forEach(iconItem => {
        const anchorElement = iconItem.parentNode;
        const shareUrl = window.location.href;
        // console.log(shareUrl);
        const encodedLink = encodeURI(shareUrl);
        // console.log(encodedLink);
        const fbShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedLink}`;
        anchorElement.href = fbShareUrl;
        // anchorElement.addEventListener('click', (e) => {
        //     e.preventDefault();
        //     // const currentHref = anchorElement.href;
        //     // console.log(currentHref);
        //     // const urlParams = new URL(currentHref).searchParams;
        //     // const shareUrl = urlParams.get('url');
        //
        //     window.open(fbShareUrl, '_blank');
        // })
    });
});
